import { useEffect, useMemo } from 'react';

import { setSelectedDate } from '@/features/scenario/stores/scenarioSlice';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';

import { buildTimeSliderDates } from '../utils/timeSliderDates';

/**
 * Advances {@link scenarioSlice} `selectedDate` along the same timeline as {@link TimeSlider}.
 */
export function useTimeSliderPlayback(enabled: boolean): void {
  const dispatch = useAppDispatch();
  const isPlaying = useAppSelector((s) => s.scenario.timeSliderPlaying);
  const selectedDate = useAppSelector((s) => s.scenario.selectedDate);
  const historyDay = useAppSelector((s) => s.scenario.timeSliderHistoryDay);
  const selectedYear = useAppSelector((s) => s.scenario.selectedYear);
  const geeYear = useAppSelector((s) => s.map.geeParams.year);

  const playbackYear = selectedYear ?? geeYear;
  const effectiveHistoryDay = historyDay || `${playbackYear}-01-01`;

  const dates = useMemo(() => buildTimeSliderDates(effectiveHistoryDay), [effectiveHistoryDay]);

  useEffect(() => {
    if (!enabled || !isPlaying) return;
    const interval = window.setInterval(() => {
      const currentIndex = selectedDate ? dates.indexOf(selectedDate) : 0;
      const base = currentIndex === -1 ? 0 : currentIndex;
      const nextIndex = (base + 1) % dates.length;
      dispatch(setSelectedDate(dates[nextIndex]));
    }, 2000);
    return () => window.clearInterval(interval);
  }, [enabled, isPlaying, selectedDate, dates, dispatch]);
}
